module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0088.jpg?v=e7c26a17";